import React, { Component } from "react";
import "./ConversationStyleSheet.css";
import HWLog from "../HWLibrary/HWLog";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import chatBotLogo from "../../images/simplify360_logo.png";
import closeIcon from "../../images/close-icon.png";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import LanguageToggle from "../../utils/LanguageToggle/LanguageToggle";
import { s360ConfigService } from "../Services/S360Config";

class ConversationHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { isMenuOpen: false };
    this.menuContainerRef = React.createRef();
  }

  onClose = () => {
    this.props.actions &&
      this.props.actions.onHideChatWindow &&
      this.props.actions.onHideChatWindow();
    this.props.actions.onStartUpClick();
  };
  closeOnFullScreen = () => {
    window.parent.postMessage(
      {
        closeFunctionFullScreen: "true",
      },
      "*"
    );
  };
  enableFullScreen = () => {
    this.props.actions.refreshForFullScreen();
    localStorage.setItem("openInFullScreen", true);
  };
  menuItemStyle = () => {
    return {
      color: this.props.config.designDetails.listItemFontColor || "#1C165E",
      fontFamily:
        this.props.config.designDetails.selectionButtonFont || "poppins",
      fontSize:
        this.props.config.designDetails.selectionButtonFontSize + "px" ||
        "13px",
    };
  };

  onSendChatTranscriptClick = () => {
    this.setState({ isMenuOpen: false }, () => {
      this.props.onSendChatTranscriptClick();
    });
  };

  closeConversationClick = () => {
    let tempIsFullScreen = localStorage.getItem("openInFullScreen");
    //todo : bob
    if (tempIsFullScreen) {
      this.closeOnFullScreen();
    } else {
      this.setState({ isMenuOpen: false }, () => {
        this.props.closeConversationClick();
      });
    }
  };

  startNewConversation = () => {
    this.setState({ isMenuOpen: false }, () => {
      this.props.startNewConversation();
    });
  };

  showActiveText = () => this.props.config.configDetails?.subHeadingText || "ACTIVE NOW"

  parseName = () => {
    if(sessionStorage.getItem("agentName")) {
      return sessionStorage.getItem("agentName")
    } else {
      return this.props.config.configDetails?.defaultBotName
    }
  }

  userImageStyle = () => {
    let config = this.props.config;
    return {};
  };

  menuOptionImage = (visible) => {
    let color = this.props.config.designDetails.pageBackgroundColor;
    return (
      <svg
        visibility={visible ? "visible" : "hidden"}
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        // width="150" height="150"
        viewBox="0 0 50 50"
        onClick={this.onMenuAction}
        style={this.menuOptionImageStyle()}
      >
        <path d="M 8 20 C 4.6875 20 2 22.6875 2 26 C 2 29.3125 4.6875 32 8 32 C 11.3125 32 14 29.3125 14 26 C 14 22.6875 11.3125 20 8 20 Z M 25 20 C 21.6875 20 19 22.6875 19 26 C 19 29.3125 21.6875 32 25 32 C 28.3125 32 31 29.3125 31 26 C 31 22.6875 28.3125 20 25 20 Z M 42 20 C 38.6875 20 36 22.6875 36 26 C 36 29.3125 38.6875 32 42 32 C 45.3125 32 48 29.3125 48 26 C 48 22.6875 45.3125 20 42 20 Z"></path>
      </svg>
    );
  };

  menuOptionImageStyle = () => {
    return {
      fill: isNullOrUndefined(this.props.config.designDetails.menuOptionscolor)
        ? "black"
        : this.props.config.designDetails.menuOptionscolor,
      width: "20px",
    };
  };

  menuOptionClose = () => {
    this.setState({ isMenuOpen: false });
  };

  headerBackImage = () => {
    let color = this.props.config.designDetails.pageBackgroundColor;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        // width="96" height="96"
        viewBox="0 0 24 24"
        onClick={this.onBackAction}
        style={this.backButtonStyle()}
      >
        {" "}
        <path d="M 10 5.3417969 C 9.744125 5.3417969 9.4879688 5.4412187 9.2929688 5.6367188 L 3.6367188 11.292969 C 3.2457187 11.683969 3.2457187 12.317031 3.6367188 12.707031 L 9.2929688 18.363281 C 9.6839688 18.754281 10.317031 18.754281 10.707031 18.363281 L 10.792969 18.277344 C 11.183969 17.886344 11.183969 17.253281 10.792969 16.863281 L 6.9296875 13 L 20 13 C 20.552 13 21 12.552 21 12 C 21 11.448 20.552 11 20 11 L 6.9296875 11 L 10.792969 7.1367188 C 11.183969 6.7457187 11.183969 6.1126563 10.792969 5.7226562 L 10.707031 5.6367188 C 10.511531 5.4412187 10.255875 5.3417969 10 5.3417969 z"></path>
      </svg>
    );
  };
  backButtonStyle = () => {
    return {
      fill: isNullOrUndefined(this.props.config.designDetails.backButtonColor)
        ? "black"
        : this.props.config.designDetails.backButtonColor,
    };
  };

  headerIconStyle = () => {
    return {
      fill: isNullOrUndefined(this.props.config.designDetails.headerIconColor)
        ? "#1f175c"
        : this.props.config.designDetails.headerIconColor,
    };
  };

  onMenuAction = (event) => {
    let anchorEl = event.currentTarget;
    this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
  };

  onBackAction = () => {
    this.props.actions.showLandingScreen();
  };

  containerStyle = () => {
    let config = this.props.config;
    return {
      background:
        config.designDetails.headerBackgroundImage !== undefined &&
        config.designDetails.headerBackgroundImage !== ""
          ? "url(" + config.designDetails.headerBackgroundImage + ")"
          : config.designDetails.conversationPageHeaderColor,
      color: config.designDetails.headerFontColor,
      fontFamily: config.designDetails.headerFont,
      fontSize: config.designDetails.headerFontSize,
      width: "100%",
    };
  };

  render() {
    const isFullScreen = localStorage.getItem("openInFullScreen");
    let placeholderPic =
      "https://hummingwave-image-util.s3.amazonaws.com/agent-3x.png";
    let agentProfilePic =
      (this.props.activeConversation &&
        this.props.activeConversation.agentInfo &&
        this.props.activeConversation.agentInfo.userProfilePic) ||
      placeholderPic;
    let isActiveConversation = this.props.isActiveConversation();
    let canDownloadTranscript =
      (this.props.config &&
        this.props.config.configDetails &&
        this.props.config.configDetails.sendChatTranscript) ||
      false;
    let statusColor =
      this.props.conversation &&
      this.props.conversation.agentInfo &&
      this.props.conversation.agentInfo.isActive === true
        ? "#e60000"
        : "#00cc00";

    let isSendChatTranscriptVisible = canDownloadTranscript ? true : false;
    let isManualSessionActionEnabled =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.allowManualSessionEnd === true;
    let isFullScreenButtonEnabled =
      this.props.config && this.props.config.fullScreenButton === true;

    let enableCloseConversation = this.props?.config?.forceCloseButton;
    let showMizimizeOnFullScreen =
      s360ConfigService?.config?.showMinimizeIconInFullScreen;
    const isAnyMenuActionsEnabled =
      isSendChatTranscriptVisible || isManualSessionActionEnabled;
    // let agentDisplayInitials = (this.props.activeConversation.agentInfo  && this.props.activeConversation.agentInfo.firstName && this.props.activeConversation.agentInfo.lastName )? this.props.activeConversation.agentInfo.firstName.charAt(0) +""+ this.props.activeConversation.agentInfo.lastName.charAt(0) : "B";
    // let styleBkg = {"paddingTop":"15%","width":"30px","height":"30px","color":"#fff","textAlign":"center","borderRadius":"50%","verticalAlign":"middle","fontSize":"15px","fontWeight":"bold"}
    let styleBkg = { borderRadius: "50%", fontSize: "15px" };
    const colors = ["#c797fc", "#ff9ba6", "#ff91e2", "#66b784"];
    let hideHis = this.props.config.hideChatHis;
    let showLogo = isNullOrUndefined(this.props.config.showLogo)
      ? true
      : this.props.config.showLogo;

    const { isShowToggle } = this.props;
    console.log("isShowToggle", isShowToggle);

    return (
      <div
        className="s360-conversation-header-container"
        style={this.containerStyle()}
      >
        <div style={{ width: "100%", paddingLeft: 8, display: "flex", alignItems: "center", gap: '2px' }}>
          {!hideHis && (
            <div className="s360-conversation-header-back-button">
              {this.headerBackImage()}
            </div>
          )}
          {/* <div className="s360-conversation-header-details-container" style={{marginLeft:this.props.config.hideChatHis ? "3%" : "0%"}}> */}
          {showLogo && (
            <div
              className={
                localStorage.getItem("openInFullScreen")
                  ? "s360-conversation-header-details-image-fs"
                  : "s360-conversation-header-details-image"
              }
              style={this.userImageStyle()}
            >
              {/* <div id="headerImgDiv" style={styleBkg}>{agentDisplayInitials}</div> */}
              <div id="headerImgDiv" style={styleBkg}>
                <img
                  style={{
                    width: `${this.props.config.designDetails.iconWidth}px` || "auto",
                    height: `${this.props.config.designDetails.iconHeight}px` || "26px",
                  }}
                  src={this.props.config.configDetails.brandIcon}
                  alt="/"
                />
              </div>
              {/* <img style={{ background: "white", width: "100%", height: "100%", borderRadius: "20px", overflow: "hidden" }} src={agentProfilePic} alt="" /> */}
              {/* <div className="s360-conversation-header-agent-ping-status-container"><div className="s360-conversation-header-agent-ping-status" style={{ display: (this.props.agentPingStatus && this.props.activeConversation.agentInfo && this.props.activeConversation.agentInfo.agentId != 0) ? "block" : "none", backgroundColor: (this.props.agentPingStatus || "red").toLowerCase() }} ></div></div> */}
            </div>
          )}
          {!this.props.config.configDetails.disableTypingIndicatorStatus ? (
            <div style={{ paddingBottom: "14px" }} >
              <div className="s360-conversation-header-agent-ping-status-container">
                <div className="s360-conversation-header-agent-ping-status" style={{ backgroundColor: statusColor }} />
              </div>
            </div>
          ) : null}
          <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div
              className={
                localStorage.getItem("openInFullScreen")
                  ? "s360-conversation-header-details-title-fs"
                  : "s360-conversation-header-details-title"
              }
              title={this.parseName()}
            >
              {this.parseName()}
            </div>
            {!this.props.config.configDetails.disableTypingIndicatorText ? (
              <div className="s360-conversation-typing-indicator">
                {this.showActiveText()}
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={
            isFullScreen
              ? "s360-conversation-header-container-menu-container-fs"
              : "s360-conversation-header-container-menu-container"
          }
          style={{ fontFamily: "poppins", fontSize: "13px" }}
        >
          {this.props.config.languageSwitcher && isShowToggle ? (
            <LanguageToggle {...this.props} />
          ) : null}
          {isManualSessionActionEnabled ? (
            <div ref={this.menuContainerRef} className="menu-item">
              {canDownloadTranscript &&
                isActiveConversation &&
                this.menuOptionImage(isAnyMenuActionsEnabled)}
              {isAnyMenuActionsEnabled && (
                <Menu
                  key={"options-menu-" + this.state.isMenuOpen}
                  anchorEl={this.menuContainerRef.current}
                  open={this.state.isMenuOpen === true}
                  onClose={this.menuOptionClose}
                >
                  {canDownloadTranscript && (
                    <MenuItem
                      onClick={this.onSendChatTranscriptClick}
                      style={this.menuItemStyle()}
                    >
                      Send chat transcript
                    </MenuItem>
                  )}
                  {isManualSessionActionEnabled && isActiveConversation && (
                    <MenuItem
                      style={this.menuItemStyle()}
                      //this is to popup survey
                      onClick={this.closeConversationClick}
                      //this is to directly start without any survey
                      // onClick={this.startNewConversation}
                    >
                      Restart Conversation
                    </MenuItem>
                  )}
                </Menu>
              )}
              {canDownloadTranscript && !isActiveConversation && (
                <div
                  onClick={this.onSendChatTranscriptClick}
                  style={{ cursor: "pointer" }}
                ></div>
              )}
              {isManualSessionActionEnabled &&
                !canDownloadTranscript &&
                isActiveConversation &&
                s360ConfigService?.config?.hideCloseOnAgent &&
                !sessionStorage.getItem("agentConnected") &&
                (isNullOrUndefined(this.props.config.forceCloseButton)
                  ? true
                  : this.props.config.forceCloseButton) && (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={this.closeConversationClick}
                  >
                    <img height={"10px"} width={"10px"} src={closeIcon}></img>
                  </div>
                )}
            </div>
          ) : null}

         {!this.props.config.isHidecloseIcon&&(isFullScreen ? (
            showMizimizeOnFullScreen ? (
              <div
                className="s360-conversation-header-icon"
                onClick={this.onClose}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.624"
                  height="53px"
                  viewBox="0 0 13.624 8.209"
                >
                  <path
                    id="down-arrow"
                    d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                    transform="translate(-2364.171 -5054.96)"
                    style={this.headerIconStyle()}
                  />
                </svg>
              </div>
            ) : (
              <div
                className="s360-conversation-header-icon"
                onClick={this.closeConversationClick}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M1 1L13 13"
                    stroke="#333333"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )
          ) : s360ConfigService?.config?.showCloseIcon ? (
            <div
              className="s360-conversation-header-icon"
              onClick={this.closeConversationClick}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1L1 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 1L13 13"
                  stroke="#333333"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          ) : (
            <div
              className="s360-conversation-header-icon"
              onClick={this.onClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53px"
                viewBox="0 0 13.624 8.209"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  style={this.headerIconStyle()}
                />
              </svg>
            </div>
          ))}
          {/* <div ref={this.menuContainerRef} onClick={this.onOpen} className="s360-conversation-header-menu-option">
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.624"  height="53" viewBox="0 0 13.624 8.209">
                     <path id="down-arrow" d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z" transform="translate(-2364.171 -5054.96)" fill="#1f175c"/></svg>
                  </div> */}
        </div>
      </div>
    );
  }
}

export default ConversationHeader;
